import gql from "graphql-tag";

export const GET_EMAILS_BY_STATUS_ID = gql`
  query getStatusEmails($statusId: Int!) {
    getStatusEmails(status_id: $statusId) {
      email
    }
  }
`;
